import React from 'react'

const IdentityStep = ({ data, onChange, onNext, onBack }) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    onNext()
  }

  return (
    <div className="view active">
      <div className="panel">
        <div className="panel-head" style={{
          background: 'linear-gradient(135deg,var(--navy) 0%,var(--navy3) 100%)',
          padding: '32px 36px 28px',
          borderBottom: '3px solid var(--gold)'
        }}>
          <div className="panel-title" style={{
            fontFamily: 'var(--font-d)',
            fontSize: '26px',
            color: 'var(--white)',
            marginBottom: '6px'
          }}>
            Identity Verification
          </div>
          <div className="panel-subtitle" style={{
            fontSize: '14px',
            color: 'rgba(255,255,255,0.55)',
            fontWeight: '300'
          }}>
            Required by IPST compliance and Story Protocol IPA registration. Uses the same standards as banks and licensed crypto firms.
          </div>
        </div>
        
        <div className="panel-body" style={{ padding: '36px' }}>
          <div className="info-bar" style={{
            background: 'rgba(13,158,124,0.07)',
            border: '1px solid rgba(13,158,124,0.2)',
            borderRadius: 'var(--r)',
            padding: '14px 18px',
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-start',
            marginBottom: '24px'
          }}>
            <div className="icon" style={{ fontSize: '18px', flexShrink: 0, marginTop: '1px' }}>🏦</div>
            <p style={{ fontSize: '13px', color: 'var(--text2)', lineHeight: '1.6' }}>
              Identity verification follows <strong>FinCEN Bank Secrecy Act</strong> and <strong>SEC KYC/AML</strong> requirements. 
              Your document images and biometric data are encrypted, never stored in plain text, and processed by IPST's licensed identity verification partner.
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{
              textAlign: 'center',
              padding: '40px',
              background: 'var(--off)',
              borderRadius: 'var(--r2)',
              border: '2px dashed var(--border)'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📸</div>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: 'var(--text)',
                marginBottom: '8px'
              }}>
                Identity Verification Coming Soon
              </h3>
              <p style={{
                fontSize: '14px',
                color: 'var(--text3)',
                lineHeight: '1.6'
              }}>
                This step will include government ID upload, facial recognition, and liveness verification.
              </p>
            </div>

            <div className="btn-actions" style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end',
              marginTop: '28px',
              paddingTop: '24px',
              borderTop: '1px solid var(--border)'
            }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onBack}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '13px 28px',
                  borderRadius: 'var(--r)',
                  fontFamily: 'var(--font-b)',
                  fontSize: '14px',
                  fontWeight: '600',
                  letterSpacing: '0.02em',
                  cursor: 'pointer',
                  border: '1.5px solid var(--border)',
                  background: 'transparent',
                  color: 'var(--text2)',
                  transition: 'all 0.2s'
                }}
              >
                ← Back
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '13px 28px',
                  borderRadius: 'var(--r)',
                  fontFamily: 'var(--font-b)',
                  fontSize: '14px',
                  fontWeight: '600',
                  letterSpacing: '0.02em',
                  cursor: 'pointer',
                  border: 'none',
                  transition: 'all 0.2s',
                  background: 'var(--gold)',
                  color: 'var(--navy)',
                  boxShadow: '0 4px 16px rgba(201,168,76,0.3)'
                }}
              >
                Continue to NIL Profile →
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default IdentityStep
